import { ChangeEventHandler } from 'react';

import { FormControl, Stack, Switch, TextField } from '@mui/material';

import { Typography } from 'components/atoms/Typography';
import { SectionConfig } from 'types/builder/componentConfig';

type SectionControlProps = {
    node?: SectionConfig;
    onChange: (node?: SectionConfig) => void;
};

export const SectionControl = ({
    onChange,
    node,
}: SectionControlProps): JSX.Element => {
    const {
        noMargin = false,
        sectionTitle,
        showInHeader = false,
    } = node?.props || {};

    const onMarginChange = (val: boolean): void => {
        onChange({
            component: 'section',
            props: {
                ...node?.props,
                noMargin: val,
            },
        });
    };
    const onHeaderChange = (val: boolean): void => {
        onChange({
            component: 'section',
            props: {
                ...node?.props,
                showInHeader: val,
            },
        });
    };

    const onTitleChange: ChangeEventHandler<HTMLInputElement> = (e): void => {
        const { value } = e.target;

        onChange({
            component: 'section',
            props: {
                ...node?.props,
                sectionTitle: value,
            },
        });
    };

    return (
        <Stack spacing={2}>
            <FormControl variant="outlined">
                <TextField
                    label="Заголовок раздела"
                    size="small"
                    fullWidth
                    value={sectionTitle || ''}
                    onChange={onTitleChange}
                />
            </FormControl>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography>Отступы раздела</Typography>
                <Switch
                    name="showBottomNavLink"
                    checked={!noMargin}
                    onChange={(e, v) => onMarginChange(!v)}
                />
            </Stack>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography>Показывать в шапке</Typography>
                <Switch
                    name="showBottomNavLink"
                    checked={showInHeader}
                    onChange={(e, v) => onHeaderChange(v)}
                />
            </Stack>
        </Stack>
    );
};
